import React from 'react';
import { CheckSquare } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const CompliancePage = () => {
  const serviceData = {
    icon: CheckSquare,
    nameAr: 'دائرة الامتثال والحوكمة',
    nameEn: 'Compliance and Governance Department',
    taglineAr: 'بناء أنظمة الامتثال وتطبيق معايير الحوكمة',
    taglineEn: 'Building compliance systems and implementing governance standards',
    
    descriptionAr: [
      'دائرة الامتثال والحوكمة في وازن متخصصة في مساعدة الشركات على بناء وتطبيق أنظمة الامتثال والحوكمة وفق المعايير الدولية والمحلية. نقدم حلولاً شاملة تضمن توافق منظمتكم مع جميع الأنظمة واللوائح.',
      'نساعد الشركات في إدارة المخاطر القانونية والتنظيمية، وبناء سياسات وإجراءات عمل فعالة تضمن التزام المنظمة بأعلى معايير الحوكمة والنزاهة.'
    ],
    descriptionEn: [
      'Wazin\'s Compliance and Governance Department specializes in helping companies build and implement compliance and governance systems according to international and local standards. We provide comprehensive solutions ensuring your organization\'s compliance with all regulations and bylaws.',
      'We help companies manage legal and regulatory risks, and build effective policies and procedures ensuring the organization\'s commitment to the highest standards of governance and integrity.'
    ],

    services: [
      {
        nameAr: 'إعداد سياسات الامتثال الداخلي للشركات والمنشآت',
        nameEn: 'Preparing internal compliance policies for companies and establishments',
        descAr: 'تصميم وإعداد سياسات امتثال شاملة تضمن التزام المنشأة بجميع الأنظمة واللوائح',
        descEn: 'Designing and preparing comprehensive compliance policies ensuring establishment adherence to all regulations'
      },
      {
        nameAr: 'تصميم وتطبيق نماذج الحوكمة المؤسسية',
        nameEn: 'Designing and implementing institutional governance models',
        descAr: 'بناء أنظمة حوكمة مؤسسية وفق أفضل المعايير المحلية والدولية',
        descEn: 'Building institutional governance systems according to best local and international standards'
      },
      {
        nameAr: 'إعداد أدلة الموظف ولوائح السلوك الوظيفي',
        nameEn: 'Preparing employee manuals and professional conduct regulations',
        descAr: 'إعداد أدلة شاملة للموظفين تتضمن السياسات والإجراءات ومعايير السلوك المهني',
        descEn: 'Preparing comprehensive employee manuals including policies, procedures, and professional conduct standards'
      },
      {
        nameAr: 'إعداد وإصدار لوائح تنظيم العمل وفق نظام العمل السعودي',
        nameEn: 'Preparing work regulation bylaws according to Saudi Labor Law',
        descAr: 'إعداد وإصدار لوائح تنظيم العمل الداخلية بما يتوافق مع نظام العمل السعودي',
        descEn: 'Preparing and issuing internal work regulation bylaws in compliance with Saudi Labor Law'
      },
      {
        nameAr: 'مراجعة مدى التزام المنشأة بالأنظمة واللوائح ذات العلاقة',
        nameEn: 'Reviewing establishment compliance with relevant regulations',
        descAr: 'إجراء مراجعة شاملة لمدى التزام المنشأة بالأنظمة المحلية والدولية',
        descEn: 'Conducting comprehensive review of establishment compliance with local and international regulations'
      },
      {
        nameAr: 'إجراء تقييم قانوني شامل للشركات من منظور الامتثال والحوكمة',
        nameEn: 'Conducting comprehensive legal assessment from compliance and governance perspective',
        descAr: 'تقييم شامل للوضع القانوني للشركة من حيث الامتثال والحوكمة',
        descEn: 'Comprehensive assessment of company legal status regarding compliance and governance'
      },
      {
        nameAr: 'تنفيذ تدقيق امتثال دوري (Compliance Audit) وتقديم التقارير',
        nameEn: 'Implementing periodic compliance audit and providing reports',
        descAr: 'إجراء عمليات تدقيق دورية للامتثال وإصدار تقارير تفصيلية بالنتائج والتوصيات',
        descEn: 'Conducting periodic compliance audits and issuing detailed reports with findings and recommendations'
      },
      {
        nameAr: 'إعداد سياسات وإجراءات مكافحة الاحتيال والرشوة وتضارب المصالح',
        nameEn: 'Preparing anti-fraud, anti-bribery, and conflict of interest policies',
        descAr: 'تصميم سياسات وإجراءات شاملة لمكافحة الفساد والاحتيال وإدارة تضارب المصالح',
        descEn: 'Designing comprehensive policies and procedures to combat corruption, fraud, and manage conflict of interest'
      }
    ],

    specializations: [
      { ar: 'الامتثال للقطاع المالي', en: 'Financial Sector Compliance' },
      { ar: 'الامتثال للأمن السيبراني', en: 'Cybersecurity Compliance' },
      { ar: 'الامتثال لحماية البيانات (GDPR)', en: 'Data Protection Compliance (GDPR)' },
      { ar: 'مكافحة غسل الأموال (AML)', en: 'Anti-Money Laundering (AML)' },
      { ar: 'الامتثال الضريبي', en: 'Tax Compliance' },
      { ar: 'حوكمة الشركات العائلية', en: 'Family Business Governance' },
      { ar: 'الامتثال لقطاع الصحة', en: 'Healthcare Compliance' },
      { ar: 'سياسات مكافحة الفساد', en: 'Anti-Corruption Policies' },
      { ar: 'الامتثال لقطاع التقنية', en: 'Technology Sector Compliance' },
      { ar: 'معايير ISO', en: 'ISO Standards' }
    ],

    faqs: [
      {
        questionAr: 'لماذا تحتاج شركتي إلى نظام امتثال؟',
        questionEn: 'Why does my company need a compliance system?',
        answerAr: 'نظام الامتثال يحمي شركتك من المخاطر القانونية، الغرامات، والعقوبات. كما يحسن سمعة الشركة ويزيد من ثقة العملاء والمستثمرين، ويضمن التزام الشركة بجميع الأنظمة واللوائح المحلية والدولية.',
        answerEn: 'A compliance system protects your company from legal risks, fines, and penalties. It also improves company reputation, increases client and investor confidence, and ensures company compliance with all local and international regulations and bylaws.'
      },
      {
        questionAr: 'كم يستغرق بناء نظام امتثال؟',
        questionEn: 'How long does it take to build a compliance system?',
        answerAr: 'يختلف حسب حجم ونوع الشركة، لكن عادةً يستغرق من 3 إلى 6 أشهر لبناء نظام امتثال متكامل يشمل جميع السياسات، الإجراءات، والتدريب.',
        answerEn: 'It varies depending on company size and type, but usually takes 3 to 6 months to build a complete compliance system including all policies, procedures, and training.'
      },
      {
        questionAr: 'ما الفرق بين الامتثال والحوكمة؟',
        questionEn: 'What is the difference between compliance and governance?',
        answerAr: 'الامتثال هو التزام الشركة بالأنظمة والقوانين الخارجية، بينما الحوكمة هي النظام الداخلي لإدارة الشركة واتخاذ القرارات. كلاهما يكمل الآخر لضمان إدارة سليمة للشركة.',
        answerEn: 'Compliance is the company\'s adherence to external regulations and laws, while governance is the internal system for managing the company and making decisions. Both complement each other to ensure sound company management.'
      },
      {
        questionAr: 'هل توفرون تدريباً للموظفين؟',
        questionEn: 'Do you provide employee training?',
        answerAr: 'نعم، نقدم برامج تدريبية شاملة لجميع مستويات الموظفين على سياسات وإجراءات الامتثال، مع مواد تدريبية مخصصة لكل قسم ووظيفة.',
        answerEn: 'Yes, we provide comprehensive training programs for all employee levels on compliance policies and procedures, with customized training materials for each department and position.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default CompliancePage;